const PARAMETER_NAME = "fbclid";
const PLACEHOLDER_URL = "http://example.com";
const EMPTY_FBCLID = "";

type SearchParams = Record<string, string>;

function applySearchParams(url: URL, params: SearchParams): URL {
	const existingParams = new URLSearchParams(url.search);

	for (const [key, value] of Object.entries(params)) {
		existingParams.set(key, value);
	}

	url.search = existingParams.toString();

	return url;
}

function handleRelativeUrl(url: string, params: SearchParams): string {
	const validUrl = new URL(url, PLACEHOLDER_URL);

	const urlWithParams = applySearchParams(validUrl, params);

	return urlWithParams.toString().replace(PLACEHOLDER_URL, "");
}

function addParameters(url: string | URL | undefined, params: SearchParams) {
	if (url === undefined) {
		return "";
	}

	try {
		if (typeof url === "string" && url.startsWith("/")) {
			return handleRelativeUrl(url, params);
		}

		url = new URL(url);

		return applySearchParams(url, params).toString();
	} catch (_) {
		// Last ditch effort
		if (typeof url === "string") {
			const hasParams = url.lastIndexOf("?") !== -1;
			const separator = hasParams ? "&" : "?";

			const additionalParams = new URLSearchParams(params).toString();

			return `${url}${separator}${additionalParams}`;
		}

		return url.toString();
	}
}

export function wrapUrlWithFbclid(
	url: string | URL,
	fbclid: string | undefined,
) {
	if (fbclid === undefined || fbclid.trim().length === 0) {
		return url.toString();
	}

	return addParameters(url, { [PARAMETER_NAME]: fbclid });
}

export function extractFbclid(url: string | URL | undefined) {
	try {
		if (url === undefined) {
			return EMPTY_FBCLID;
		}

		const urlObject = new URL(url);
		const searchParams = new URLSearchParams(urlObject.search);

		return searchParams.get(PARAMETER_NAME) ?? EMPTY_FBCLID;
	} catch (_) {
		return EMPTY_FBCLID;
	}
}

export function extractFbclidClient() {
	return extractFbclid(window.location.href);
}
